import { jsx as _jsx } from "react/jsx-runtime";
import { GroupDetail } from '@/components/grupos/GroupDetail';
export function GroupDetailPage() {
    return _jsx(GroupDetail, {});
}
//# sourceMappingURL=GroupDetailPage.js.map